import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Logout } from '../../../state/actions/merchant.actions';

@Component({
  selector: 'app-card-controls',
  templateUrl: './card-controls.component.html',
  styleUrls: ['./card-controls.component.scss'],
})
export class CardControlsComponent {
  constructor(private store: Store) {}

  onLogout(): void {
    this.store.dispatch(new Logout());
  }
}
